import Icon from "~/components/shared/Icon";
import CopyButton from "~/components/shared/CopyButton";
import { updateUrlTags, BRANCH_KEY } from "~/components/analytics/shared/tagHelpers";

const BranchLink = ({ branch }: { branch: string }) => (
  <a
    className="color-inherit max-w-[350px] truncate no-underline hover:underline"
    href={updateUrlTags({ key: BRANCH_KEY, value: branch })}
  >
    {branch}
  </a>
);

const Branch = ({ branch, linkToBranchTag }: { branch: string; linkToBranchTag?: boolean }) => (
  <span className="color-inherit flex items-center">
    <Icon icon="custom/outline/14x/branch" style={{ height: 14, width: 14 }} className="shrink-0" />
    {linkToBranchTag ? (
      <BranchLink branch={branch} />
    ) : (
      <span className="max-w-[350px] truncate">{branch}</span>
    )}
    <CopyButton contentToCopy={branch} iconOnly={true} />
  </span>
);

export default Branch;
